// Na nuvem (Docker) REACT_APP_API_BASE="" => mesma origem, nginx faz proxy /api.
// No dev local (var não definida) => cai no IP da máquina que roda o backend.
const API_BASE_URL =
  process.env.REACT_APP_API_BASE ?? 'http://192.168.15.75:8090';
const API_USER = 'cristiano';

class LifeAssistantService {
  constructor(baseUrl = API_BASE_URL, user = API_USER) {
    this.baseUrl = baseUrl;
    this.user = user;
  }

  async fetch(endpoint) {
    try {
      const url = `${this.baseUrl}${endpoint}`;
      console.log(`Fetching: ${url}`);

      const response = await fetch(url, { credentials: 'include' });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error(`Fetch error on ${endpoint}:`, error);
      throw error;
    }
  }

  async getTodaySummary() {
    return this.fetch(`/api/today?user=${this.user}`);
  }

  async getHealthData(days = 7) {
    return this.fetch(`/api/health?user=${this.user}&days=${days}`);
  }

  async getCalendarEvents(days = 30) {
    return this.fetch(`/api/events?user=${this.user}&days=${days}`);
  }

  deleteCalendarEvent(id) {
    return this.post(`/api/events/delete?user=${this.user}`, { id });
  }

  async getStats() {
    return this.fetch(`/api/stats?user=${this.user}`);
  }

  async getWeather() {
    return this.fetch(`/api/weather?user=${this.user}`);
  }

  async getNews(force = false) {
    return this.fetch(`/api/news?user=${this.user}${force ? '&force=true' : ''}`);
  }

  async getEmails() {
    return this.fetch(`/api/emails?user=${this.user}`);
  }

  async post(endpoint, body) {
    const url = `${this.baseUrl}${endpoint}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return response.json();
  }

  // ===== Autenticação =====
  signup(email, password, name, acceptedPrivacyPolicy) {
    return this.post('/api/auth/signup', {
      email, password, name, accepted_privacy_policy: acceptedPrivacyPolicy,
    });
  }

  login(email, password) {
    return this.post('/api/auth/login', { email, password });
  }

  async logout() {
    return this.post('/api/auth/logout', {});
  }

  async me() {
    const response = await fetch(`${this.baseUrl}/api/auth/me`, { credentials: 'include' });
    if (!response.ok) return null;
    return response.json();
  }

  forgotPassword(email) {
    return this.post('/api/auth/forgot-password', { email });
  }

  resetPassword(token, password) {
    return this.post('/api/auth/reset-password', { token, password });
  }

  getAdminUsers() {
    return this.fetch('/api/admin/users');
  }

  setAdminUserAiAccess(id, allowed) {
    return this.post('/api/admin/users/ai-access', { id, allowed });
  }

  getEmailFilters() {
    return this.fetch(`/api/email-filters?user=${this.user}`);
  }

  saveEmailFilters(filterKey, senders) {
    return this.post(`/api/email-filters?user=${this.user}`, {
      filter_key: filterKey,
      senders,
    });
  }

  getFinance() {
    return this.fetch(`/api/finance?user=${this.user}`);
  }

  getStatus() {
    return this.fetch(`/api/status?user=${this.user}`);
  }

  getCompare() {
    return this.fetch(`/api/compare?user=${this.user}`);
  }

  getAnalise(force = false) {
    return this.fetch(`/api/analise?user=${this.user}${force ? '&force=true' : ''}`);
  }

  getHealthHourly() {
    return this.fetch(`/api/health/hourly?user=${this.user}`);
  }

  getHealthMetrics() {
    return this.fetch(`/api/health/metrics?user=${this.user}`);
  }

  getHealthAll() {
    return this.fetch(`/api/health/all?user=${this.user}`);
  }

  getRecovery() {
    return this.fetch(`/api/recovery?user=${this.user}`);
  }

  getEcgWaveform(ecgId) {
    return this.fetch(`/api/health/ecg/${ecgId}?user=${this.user}`);
  }

  getProfile() {
    return this.fetch(`/api/profile?user=${this.user}`);
  }

  saveProfile(birthDate) {
    return this.post(`/api/profile?user=${this.user}`, { birth_date: birthDate });
  }

  saveWeight(pesoKg) {
    return this.post(`/api/profile?user=${this.user}`, { peso_kg: pesoKg });
  }

  saveSexo(valor) {
    return this.post(`/api/profile?user=${this.user}`, { sexo: valor });
  }

  saveFontePreferidaTreino(valor) {
    return this.post(`/api/profile?user=${this.user}`, { preferencia_fonte_treino: valor });
  }

  saveFoodAllergies(text) {
    return this.post(`/api/profile?user=${this.user}`, { alergias_alimentares: text });
  }

  saveFullName(fullName) {
    return this.post(`/api/profile?user=${this.user}`, { full_name: fullName });
  }

  saveApelido(apelido) {
    return this.post(`/api/profile?user=${this.user}`, { apelido });
  }

  saveAnalisesPorDia(n) {
    return this.post(`/api/profile?user=${this.user}`, { analises_por_dia: n });
  }

  saveAnthropicApiKey(key) {
    return this.post(`/api/profile?user=${this.user}`, { anthropic_api_key: key });
  }

  saveMetasSaude(metas) {
    return this.post(`/api/profile?user=${this.user}`, metas);
  }

  getGoals() {
    return this.fetch(`/api/goals?user=${this.user}`);
  }

  createGoal(description, targetDate) {
    return this.post(`/api/goals?user=${this.user}`, { description, target_date: targetDate });
  }

  toggleGoal(id) {
    return this.post(`/api/goals/toggle?user=${this.user}`, { id });
  }

  deleteGoal(id) {
    return this.post(`/api/goals/delete?user=${this.user}`, { id });
  }

  getNewsPreferences() {
    return this.fetch(`/api/preferences/news?user=${this.user}`);
  }

  saveNewsPreferences(topics, newsCount) {
    return this.post(`/api/preferences/news?user=${this.user}`, { topics, news_count: newsCount });
  }

  getBibleVerse() {
    return this.fetch(`/api/bible-verse?user=${this.user}`);
  }

  getBodyComposition(limit = 30) {
    return this.fetch(`/api/body-composition?user=${this.user}&limit=${limit}`);
  }

  async uploadBodyComposition(file) {
    const form = new FormData();
    form.append('file', file);
    const response = await fetch(`${this.baseUrl}/api/body-composition/upload?user=${this.user}`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return response.json();
  }

  getStudyPlans() {
    return this.fetch(`/api/study-plans?user=${this.user}`);
  }

  getStudyPlansToday() {
    return this.fetch(`/api/study-plans/today?user=${this.user}`);
  }

  createStudyPlan(plan) {
    return this.post(`/api/study-plans?user=${this.user}`, plan);
  }

  updateStudyPlan(plan) {
    return this.post(`/api/study-plans/update?user=${this.user}`, plan);
  }

  addStudyPlanNote(id, text) {
    return this.post(`/api/study-plans/note?user=${this.user}`, { id, text });
  }

  async uploadStudyCertificate(id, file) {
    const form = new FormData();
    form.append('file', file);
    const response = await fetch(`${this.baseUrl}/api/study-plans/certificate?id=${id}&user=${this.user}`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return response.json();
  }

  studyCertificateUrl(id) {
    return `${this.baseUrl}/api/study-plans/certificate?id=${id}&user=${this.user}`;
  }

  deleteStudyCertificate(id) {
    return this.post(`/api/study-plans/certificate/delete?user=${this.user}`, { id });
  }

  deleteStudyPlan(id) {
    return this.post(`/api/study-plans/delete?user=${this.user}`, { id });
  }

  getActivities() {
    return this.fetch(`/api/activities?user=${this.user}`);
  }

  createActivity(name, dueDate) {
    return this.post(`/api/activities?user=${this.user}`, { name, due_date: dueDate });
  }

  toggleActivity(id) {
    return this.post(`/api/activities/toggle?user=${this.user}`, { id });
  }

  deleteActivity(id) {
    return this.post(`/api/activities/delete?user=${this.user}`, { id });
  }

  getWorkoutRoutines() {
    return this.fetch(`/api/workout/routines?user=${this.user}`);
  }

  saveWorkoutRoutine(routine) {
    return this.post(`/api/workout/routines?user=${this.user}`, routine);
  }

  deleteWorkoutRoutine(id) {
    return this.post(`/api/workout/routines/delete?user=${this.user}`, { id });
  }

  suggestWorkoutRoutines() {
    return this.post(`/api/workout/suggest?user=${this.user}`, {});
  }

  getWorkoutSuggestions() {
    return this.fetch(`/api/workout/suggestions?user=${this.user}`);
  }

  saveWorkoutSuggestions(routines) {
    return this.post(`/api/workout/suggestions?user=${this.user}`, { routines });
  }

  getMotivacional(tipo = 'dia') {
    return this.fetch(`/api/motivacional?tipo=${tipo}&user=${this.user}`);
  }

  getNutritionPlan() {
    return this.fetch(`/api/nutrition/plan?user=${this.user}`);
  }

  suggestNutritionPlan() {
    return this.post(`/api/nutrition/suggest?user=${this.user}`, {});
  }

  removeNutritionPlanMeal(index) {
    return this.post(`/api/nutrition/plan/remove-meal?user=${this.user}`, { index });
  }

  getFoodLog(days = 14) {
    return this.fetch(`/api/nutrition/log?user=${this.user}&days=${days}`);
  }

  createFoodLog(entry) {
    return this.post(`/api/nutrition/log?user=${this.user}`, entry);
  }

  deleteFoodLog(id) {
    return this.post(`/api/nutrition/log/delete?user=${this.user}`, { id });
  }

  analyzeFoodLog(id) {
    return this.post(`/api/nutrition/log/analyze?user=${this.user}`, { id });
  }

  getExams() {
    return this.fetch(`/api/exams?user=${this.user}`);
  }

  createExamResult(entry) {
    return this.post(`/api/exams?user=${this.user}`, entry);
  }

  async uploadExams(file) {
    const form = new FormData();
    form.append('file', file);
    const response = await fetch(`${this.baseUrl}/api/exams/upload?user=${this.user}`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return response.json();
  }

  saveWorkoutSession(session) {
    return this.post(`/api/workout/session?user=${this.user}`, session);
  }

  getWorkoutToday() {
    return this.fetch(`/api/workout/today?user=${this.user}`);
  }

  getWorkoutHistory(limit = 20) {
    return this.fetch(`/api/workout/history?user=${this.user}&limit=${limit}`);
  }

  getOnenoteNotebooks() {
    return this.fetch(`/api/onenote/notebooks?user=${this.user}`);
  }

  getOnenoteSections(notebookId) {
    const nb = notebookId ? `&notebook=${encodeURIComponent(notebookId)}` : '';
    return this.fetch(`/api/onenote/sections?user=${this.user}${nb}`);
  }

  getOnenotePages(sectionId) {
    const sec = sectionId ? `&section=${encodeURIComponent(sectionId)}` : '';
    return this.fetch(`/api/onenote/pages?user=${this.user}${sec}`);
  }

  getOnenotePageContent(id) {
    return this.fetch(`/api/onenote/page?user=${this.user}&id=${encodeURIComponent(id)}`);
  }

  createOnenoteSection(notebookId, name) {
    return this.post(`/api/onenote/sections?user=${this.user}`, { notebook_id: notebookId, name });
  }

  createOnenotePage(sectionId, title, content) {
    return this.post(`/api/onenote/pages?user=${this.user}`, { section_id: sectionId, title, content });
  }

  // ===== Finanças =====
  getFinanceCards() {
    return this.fetch(`/api/finance/cards?user=${this.user}`);
  }

  createFinanceCard(name, dueDay) {
    return this.post(`/api/finance/cards?user=${this.user}`, { name, due_day: dueDay });
  }

  deleteFinanceCard(id) {
    return this.post(`/api/finance/cards/delete?user=${this.user}`, { id });
  }

  getFinanceExpenses() {
    return this.fetch(`/api/finance/expenses?user=${this.user}`);
  }

  createFinanceExpense(expense) {
    return this.post(`/api/finance/expenses?user=${this.user}`, expense);
  }

  deleteFinanceExpense(id) {
    return this.post(`/api/finance/expenses/delete?user=${this.user}`, { id });
  }

  toggleFinanceExpenseOwed(id) {
    return this.post(`/api/finance/expenses/toggle-owed?user=${this.user}`, { id });
  }

  getFinanceBillSenders() {
    return this.fetch(`/api/finance/bill-senders?user=${this.user}`);
  }

  saveFinanceBillSenders(senders) {
    return this.post(`/api/finance/bill-senders?user=${this.user}`, { senders });
  }

  getFinanceBills() {
    return this.fetch(`/api/finance/bills?user=${this.user}`);
  }

  syncFinanceBills() {
    return this.post(`/api/finance/bills/sync?user=${this.user}`, {});
  }

  deleteFinanceBill(id) {
    return this.post(`/api/finance/bills/delete?user=${this.user}`, { id });
  }

  convertFinanceBill(id) {
    return this.post(`/api/finance/bills/convert?user=${this.user}`, { id });
  }

  // ===== Instagram =====
  getInstagramStatus() {
    return this.fetch(`/api/instagram/status?user=${this.user}`);
  }

  getInstagramInsights(force = false) {
    return this.fetch(`/api/instagram/insights?user=${this.user}${force ? '&force=true' : ''}`);
  }

  disconnectInstagram() {
    return this.post(`/api/instagram/disconnect?user=${this.user}`, {});
  }

  instagramConnectUrl() {
    return `${this.baseUrl}/api/auth/instagram/start?user=${this.user}`;
  }

  // ===== E-mail self-service (Gmail / Outlook) =====
  getGmailStatus() {
    return this.fetch(`/api/gmail/status?user=${this.user}`);
  }

  disconnectGmail() {
    return this.post(`/api/gmail/disconnect?user=${this.user}`, {});
  }

  gmailConnectUrl() {
    return `${this.baseUrl}/api/auth/gmail/start?user=${this.user}`;
  }

  getOutlookStatus() {
    return this.fetch(`/api/outlook/status?user=${this.user}`);
  }

  disconnectOutlook() {
    return this.post(`/api/outlook/disconnect?user=${this.user}`, {});
  }

  outlookConnectUrl() {
    return `${this.baseUrl}/api/auth/outlook/start?user=${this.user}`;
  }

  setBaseUrl(url) {
    this.baseUrl = url;
  }

  setUser(user) {
    this.user = user;
  }
}

export default new LifeAssistantService();
